import React, { useState, useEffect, useMemo, useRef } from 'react';
import classnames from 'classnames';
import { history} from 'umi';
import { useGetState } from 'ahooks';
import Filter from '@/pages/intelligence/pages/TopCharts/components/CommonFilter';
import { useIntl, connect, useSelector } from 'umi';
// import { fetchPCConsoleAllMetricsTrends } from '@/pages/intelligence/services/topcharts';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import ExportTable from '@/pages/intelligence/components/ExportTable';
import { updateDefaultTimeParams } from '@/pages/intelligence/pages/TopCharts/_config/detailDefaltfilterTime';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import useEarliestTime from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/utilsTmp/useEarliestTime';
import {
  PC_CONSOLE_COMBINE_ENTITY_TYPE,
  TopchartPageId,
} from '@intelligence/pages/TopCharts/_config/topChartsConst';
import {
  DETAIL_PAGEID,
  getDetailPageCfg,
} from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/_config';
import CombineContent from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/components/StatsContext';
import {
  getDefaultPageSortAttr,
  // getDefaultHasDataValues,
  getHasDataValues,
} from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/_utils';
import {
  getDeviceConfig,
  getMetricsTablePlatformsCascaderOptions,
} from '@/pages/intelligence/pages/TopCharts/PCGames/_config/utils';
import { createPlatformCascaderDisplayRenderConfig } from '@intelligence/_config/components/filters/platformCascaderDisplayRender';
import MetricSelect from '@/pages/intelligence/components/SelectCompoenet/MetricSelect';
import VisuailsMetricSelector from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/components/VisuailsMetricSelector';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import {
  allMetricsSourcesOption,
} from '@intelligence/pages/TopCharts/_config/metricOptions';
import {
  PC_CONSOLE_METRIC_TYPE_OPTIONS,
  filterPCConsoleMetricTypeOptionsByMetrics,
  getPCConsoleMetricDisplayCategory,
  orderPCConsoleMetrics,
} from '@intelligence/pages/TopCharts/_config/pcConsoleMetricOrdering';
import { getFilterSaveList, updateFilterSaveList } from '@/pages/intelligence/services/common';
import {
  FILTERSAVE_TYPE,
  defaultMetricList,
  defaultMetricValues,
  defaultMetricsSaveParams,
  calcVisualisMetricsValues,
  analysisAllMetricsSaveParamsStr,
  defaultMetricTypeVals,
  defaultSourceVals,
  defaultMetricsVals,
  defaultSourceMetricsApi,
  removeColumnWidth,
  getDateScopedAllMetricsOptions,
  getDateScopedAllMetricsSelection,
  generateAllMetricsSaveParams,
  rebuildSourceMetricsFromMetricValues,
} from './utils';
import type { IAllMetricsSaveParams } from './types';
import useMarketFilterApi, {
  MarketSpecailType,
} from '@/pages/intelligence/hooks/useMarketSelector';
import {
  commonPCConsoleDefaultFilterValue,
  handleDetailDigitalFilterParamsToApi,
} from '@/pages/intelligence/pages/TopCharts/_config/topchartFilterCfg';
import { FilterTimeType, getDbiFilterParams } from '@intelligence/utils/filterUtils';
import MscienceIcon from '@intelligence/assets/svg/dataSource/mscience-bg.svg';
import { getURLSearchParams, updateURLSearchParams } from '@intelligence/utils/commonUtils';
import { Button } from 'tea-component';
import { handleMetricExplanationTipsClick } from '@intelligence/v3/utils/topcharts';
import { pcconsoleStats } from '@intelligence/v3/constants/downloadLogPoint';
import { omit } from 'lodash-es';
import SteamSalesAdapter from '../SteamSales/_config/steamSalesAdapter';
import {
  expandMetricOptionsWithMultiValue,
} from '@intelligence/pages/TopCharts/utils/multiValueMetricUtils';
import { buildOrderMetricsFromPageMetricValues } from '@/pages/intelligence/components/DownloadCommon/DownloadPage/utils/reorderCombineDetailDownloadMetrics';

import './index.scss';

export default function AllMetrics(props: any) {
  const MSCIENCE_ICON = <img style={{ verticalAlign: 'text-top' }} src={MscienceIcon} />;
  const { formatMessage } = useIntl(); // 中英切换方法
  const { filterLoading, regionOptions } = useMarketFilterApi({
    filterType: MarketSpecailType.metricTable,
  });
  const platformCascaderOptions = useMemo(
    () =>
      getMetricsTablePlatformsCascaderOptions(
        {},
        createPlatformCascaderDisplayRenderConfig({
          fullCheckGroupCount: 6,
          width: 320,
        }),
      ),
    [],
  );
  const platformCascaderDefaultValue = useMemo(
    () =>
      Object.fromEntries(
        (platformCascaderOptions.children || []).map((source: any) => [
          source.value,
          [],
        ]),
      ),
    [platformCascaderOptions],
  );

  const defaultFilterValue = {
    ...commonPCConsoleDefaultFilterValue,
    [filterKeyMap.PLATFORMCASCADER]: {
      value: platformCascaderDefaultValue,
    },
  };
  const filterKeyList = [
    filterKeyMap.RANGE_TIME,
    filterKeyMap.REGION,
    filterKeyMap.DIGITAL_SEGEMENT,
    filterKeyMap.PLATFORMCASCADER,
  ];

  const filterCfg = {
    filterKeyList,
    regionFilterParams: {},
    defaultValue: defaultFilterValue,
    resetFilterValue: {
      ...defaultFilterValue,
    },
    specialParams: {
      regionOptions, // 国家筛选器options,
      getRadioOptionsTips: props?.getRadioOptionsTips,
      defalutMarket: ['global'], // 没取到交集用的默认值
      disableNoChina: true,
      rangeTimeType: FilterTimeType.commonRange,
      // disableIegg: false,
      // disableAnnie: true,
      isShowAlloftime: false,
      digitalSegementTips: formatMessage(
        { id: 'dbi_info_segement_mscience' },
        { mscienceIcon: MSCIENCE_ICON },
      ),
      entityType: props?.entityType || '',
      showRadioBubble: true,
      platformCascaderOptions,
    },
    showConfirmButton: false,
    haveFilterSaveBtn: false,
    handleFilterToApiParams: handleDetailDigitalFilterParamsToApi,
  };

  return <AllMetricsComp {...props} filterCfg={filterCfg} filterLoading={filterLoading} />;
}

const AllMetricsComp = (props: any) => {
  const {
    isBasicLoading,
    loading,
    setLoading,
    tabType,
    pageId,
    basicInfo,
    appIds,
    mainSegment,
    subSegment,
    gameId,
    entityType = 'combine',
    regionsCountries,
    isTwoMonths,
    gsdDevicesFlatten,
    gsdSegments,
    filterCfg,
    filterLoading,
  } = props;

  const filterInstance = useRef<any>(null);

  const DEFAULT_FORM_VALUE = filterCfg?.defaultValue || [];
  const topchartsState = useSelector((state: any) => state?.[DBI_TOPCHARTS] || {});
  const pageCfg = getDetailPageCfg(DETAIL_PAGEID.allMetrics, tabType, entityType);
  const defaultByDeviceVal = pageCfg?.defaultByDeviceVal || undefined;
  const deviceDefVales = getDeviceConfig(TopchartPageId.PCConsoleMetricsTable, entityType)?.value;
  const [metricSegVal, setMetricSegVal] = useState(pageCfg?.defaultSegmentVal);
  const { isOperateDetail, detailFilterExtend, setDetailFilterExtend } = useFilterExtend({});
  const [filterValue, setFilterVale] = useState(
    isOperateDetail ? detailFilterExtend : DEFAULT_FORM_VALUE,
  );

  const filterName = ''; // getFilterName(userInfo);
  const filterData: any = {}; // getFilterValueStorage(userInfo);
  const { formatMessage } = useIntl(); // 中英切换方法
  const isStatsPage = tabType === 'stats';
  const hasDevice = true;
  const isCountriesPage = tabType === 'countries';
  // 避免“先默认再覆盖”的闪动：初始化先不预选，等拉取到用户保存/默认值后一次性落到页面
  const [saveParams, setSaveParams] = useState<IAllMetricsSaveParams>({
    types: [],
    sources: [],
    metrics: [],
    source_metrics: defaultSourceMetricsApi,
  });
  const [fetchParams, setFetchParams] = useState({
    // edition_id: gameId,
    unified_ids: [gameId],
    entity_type: entityType,
    region_type: 'market',
    regions: ['global'],
    date_type: 'monthly',
    segment: 'All',
    start_date: '',
    end_date: '',
    device: hasDevice ? deviceDefVales : undefined,
    source_metrics: defaultSourceMetricsApi,
    data_method: 'date', // 固定
    // b_group_by_device: defaultByDeviceVal,
  });
  const [deviceBtn, setDeviceBtn] = useState(defaultByDeviceVal);
  const [trendLineList, setTrendLineList] = useState<any>([]);
  const [trendTableList, setTrendTableList] = useState<any>([]);
  const [trendChartType, setTrendChartType] = useState<string>(ChartType.Line);
  const [marketChartType, setMarketChartType] = useState<string>(ChartType.Line);
  const [trendChartLoading, setTrendChartLoading] = useState(true);
  const [marketTableList, setMarketTableList] = useState<any>([]);
  const [marketChartList, setMarketChartList] = useState<any>([]);
  const [trendLoading, setTrendLoading] = useState(true);
  const [sumAvgMaxList, setSumAvgMaxList] = useState([]);
  const [selectMetricsOptions, setSelectMetricsOptions, getSelectMetricsOptions] =
    useGetState(defaultMetricList);
  const [selectVisMetricsOptions, setSelectVisMetricsOptions] = useState(defaultMetricList);
  const [trendError, setTrendError] = useState(false);
  const [visuailsMetricValues, setVisuailsMetricValues] = useState<string[]>([]);
  const [metricsLoading, setMetricsLoading] = useState(true);

  // 用户是否手动修改了国家区域
  const userManuallyChangedRegionRef = useRef(Boolean(getURLSearchParams('custom_region')));
  const statsRequestSeqRef = useRef(0);
  const latestMetricsSelectionRef = useRef<{
    metrics: string[];
    source_metrics: Record<string, string[]>;
  }>({
    metrics: defaultMetricValues,
    source_metrics: defaultSourceMetricsApi,
  });

  const metricsOptionsByDateType = useMemo(
    () => orderPCConsoleMetrics(getDateScopedAllMetricsOptions(fetchParams.date_type)),
    [fetchParams.date_type],
  );

  const metricTypeOptionsByDateType = useMemo(
    () =>
      filterPCConsoleMetricTypeOptionsByMetrics(
        PC_CONSOLE_METRIC_TYPE_OPTIONS,
        metricsOptionsByDateType,
      ),
    [metricsOptionsByDateType],
  );

  const normalizeMetricsByDateType = (params: any, metricsOrder?: string[]) => {
    const resolvedMetricsOrder =
      metricsOrder ??
      latestMetricsSelectionRef.current?.metrics ??
      saveParams?.metrics ??
      (Object.values(params?.source_metrics || {}).flat() as string[]);
    const { metricsOptions, source_metrics } = getDateScopedAllMetricsSelection(
      params?.source_metrics,
      params?.date_type,
      resolvedMetricsOrder,
    );
    const hasValidSourceMetrics = Object.keys(source_metrics || {}).length > 0;
    const onlyAlineaActiveUserMetrics =
      Array.isArray(metricsOptions) &&
      metricsOptions.length > 0 &&
      metricsOptions.every((option: any) => ['alinea__dau', 'alinea__mau'].includes(option?.value));
    const shouldUseDefaultMetrics = !hasValidSourceMetrics || onlyAlineaActiveUserMetrics;
    return {
      fetchParams: {
        ...params,
        source_metrics: shouldUseDefaultMetrics ? defaultSourceMetricsApi : source_metrics,
      },
      metricsOptions: shouldUseDefaultMetrics ? defaultMetricList : metricsOptions,
    };
  };

  // 获取 AllMetricsTrends 数据（完整流程：参数转换 + API 调用 + 响应转换）
  const fetchPCConsoleAllMetricsTrends = async (params: any) => {
    return SteamSalesAdapter.fetchAllMetricsTrends(params);
  };

  const {
    earliestPeriod,
    formattedEarliestDay,
    updateEarliestDateData,
    baseReleaseTimeValue,
    baseReleaseTimeData,
  } = useEarliestTime({
    entityType,
    basicInfo,
    appIds,
    dateType: fetchParams.date_type,
    topchartsState,
  });

  const getEarliestDate = (params: any) => {
    updateEarliestDateData({
      dataSources: [],
      metrics: params.source_metrics,
      regionType: params.region_type,
      regions: params.regions,
      dateType: params.date_type,
      segment: params.segment || '',
      platform: params.device || '',
      earliesUrl: '/api/v1/intelligence_pc/gameDetail/allMetrics/earliestDate',
    });
  };

  async function getUserSaveParams(): Promise<IAllMetricsSaveParams> {
    try {
      const res = await getFilterSaveList({ type: FILTERSAVE_TYPE });
      return analysisAllMetricsSaveParamsStr(res) || {};
    } catch (err) {
      return defaultMetricsSaveParams;
    }
  }

  const updateUserSaveParams = async (params: IAllMetricsSaveParams) => {
    await updateFilterSaveList({
      name: FILTERSAVE_TYPE,
      type: FILTERSAVE_TYPE,
      data: JSON.stringify(params || {}),
    });
  };
  async function init() {
    setMetricsLoading(true);
    // 先获取筛选器值和上次保存的指标数据
    const savedParams: IAllMetricsSaveParams = await getUserSaveParams();
    let newFetchParams = {
      ...fetchParams,
      source_metrics: savedParams?.source_metrics || defaultSourceMetricsApi,
    };

    const { filterValue, filterParams } = getDbiFilterParams({
      // urlFilter: any,
      filterSaveData: filterData?.apiValue,
      filterExtend: detailFilterExtend,
      specialParams: filterCfg?.specialParams,
      isOperate: isOperateDetail,
      filterName,
      filterKeyList: filterCfg?.filterKeyList ?? Object.keys(DEFAULT_FORM_VALUE),
    });
    if (isOperateDetail) {
      // 如果目前是继承模式，就设置继承值为过滤后的筛选器值
      setDetailFilterExtend(filterValue);
    }

    setFilterVale(filterValue);
    newFetchParams = { ...newFetchParams, ...filterCfg?.handleFilterToApiParams(filterParams) };

    const sourceMetricsKeys = Object.keys(newFetchParams.source_metrics);
    const isOnlyMscienceMetric =
      sourceMetricsKeys?.length === 1 && sourceMetricsKeys[0] === 'mscience';
    if (isOnlyMscienceMetric && !userManuallyChangedRegionRef.current) {
      // 请求参数修改
      newFetchParams.regions = ['us'];

      // 表单之修改
      setFilterVale?.((prev: Record<string, any>) => {
        return {
          ...prev,
          [filterKeyMap.REGION]: {
            regions: ['us'],
            markets: ['us'],
            type: 'market',
          },
        };
      });
    }

    const normalizedMetricsParams = normalizeMetricsByDateType(
      newFetchParams,
      savedParams?.metrics,
    );
    newFetchParams = normalizedMetricsParams.fetchParams;

    getStatsData(
      newFetchParams,
      normalizedMetricsParams.metricsOptions,
      true,
      savedParams?.metrics?.length ? savedParams.metrics : undefined,
    );
    // 请求最早时间接口
    getEarliestDate(newFetchParams);
    setSaveParams(
      savedParams?.metrics?.length
        ? savedParams
        : generateAllMetricsSaveParams({
            options: normalizedMetricsParams.metricsOptions || [],
          }),
    );
    latestMetricsSelectionRef.current = {
      metrics: savedParams?.metrics?.length
        ? savedParams.metrics
        : normalizedMetricsParams.metricsOptions?.map((item: any) => item?.value) ||
          defaultMetricValues,
      source_metrics:
        savedParams?.source_metrics ||
        normalizedMetricsParams.fetchParams?.source_metrics ||
        defaultSourceMetricsApi,
    };
    // 移除列宽配置（仅影响当前 PC/Console Games Details Stats 页面）
    setSelectMetricsOptions(removeColumnWidth(normalizedMetricsParams.metricsOptions || []));

    setMetricsLoading(false);
  }

  useEffect(() => {
    // 是否请求完basic接口
    if (isBasicLoading || filterLoading) {
      // 选择单appid时要重新loading
      setLoading(true);
    } else {
      init();
    }
  }, [isBasicLoading, filterLoading]);

  const getStatsData = async (
    params: any,
    sortMetricsOptions: any[] = selectMetricsOptions,
    useDefaultMetric = true, // 可视化默认展示前2个有数据的指标；如果操作筛选器则用原来的勾选
    metricsOrder?: string[],
  ) => {
    const requestSeq = ++statsRequestSeqRef.current;
    const isLatestStatsRequest = () => requestSeq === statsRequestSeqRef.current;

    setTrendLoading(true);
    setLoading(true);
    const mergedFetchParams = { ...fetchParams, ...params };
    const normalizedMetricsParams = normalizeMetricsByDateType(
      mergedFetchParams,
      metricsOrder,
    );
    const newFetchParams = normalizedMetricsParams.fetchParams;
    const dateScopedOptionValues = new Set(
      (normalizedMetricsParams.metricsOptions || []).map((opt: any) => opt?.value),
    );
    const dateScopedSortMetricsOptions = sortMetricsOptions?.length
      ? sortMetricsOptions.filter((opt: any) =>
          dateScopedOptionValues.has(opt?.value),
        )
      : normalizedMetricsParams.metricsOptions;
    setFetchParams(newFetchParams);
    setSelectMetricsOptions(removeColumnWidth(dateScopedSortMetricsOptions || []));
    let startDate = '';
    let endDate = '';

    // filterValue region 值根据 fetchParams 的值进行变更
    if (
      newFetchParams.regions?.length === 1 &&
      newFetchParams.regions?.[0] === 'us' &&
      filterValue?.[filterKeyMap.REGION]?.regions?.length === 1 &&
      filterValue?.[filterKeyMap.REGION]?.regions?.[0] === 'global'
    ) {
      setFilterVale?.((prev: Record<string, any>) => {
        return {
          ...prev,
          [filterKeyMap.REGION]: {
            regions: ['us'],
            markets: ['us'],
            type: 'market',
          },
        };
      });
    }

    if (
      newFetchParams.regions?.length === 1 &&
      newFetchParams.regions[0] === 'global' &&
      filterValue?.[filterKeyMap.REGION]?.regions?.length === 1 &&
      filterValue?.[filterKeyMap.REGION]?.regions?.[0] === 'us'
    ) {
      setFilterVale?.((prev: Record<string, any>) => {
        return {
          ...prev,
          [filterKeyMap.REGION]: {
            regions: ['global'],
            markets: ['global'],
            type: 'market',
          },
        };
      });
    }

    try {
      const trendRes = await fetchPCConsoleAllMetricsTrends(newFetchParams);
      if (!isLatestStatsRequest()) return;
      startDate = trendRes?.req?.start_date || params?.start_date;
      endDate = trendRes?.req?.end_date || params?.end_date;
      setTrendTableList(trendRes?.data?.trends || []);
      setTrendLineList(trendRes?.data?.trends || []);
      setSumAvgMaxList(trendRes?.data?.sum_avg || []);
      const hasDataMetricsOption = getHasDataValues(
        dateScopedSortMetricsOptions,
        trendRes?.data?.trends,
        pageCfg?.getMetricValueOfCvm,
      );
      const hasDataMetricsValues = hasDataMetricsOption?.map((t) => t?.value)?.slice(0, 2);
      setVisuailsMetricValues(hasDataMetricsValues);

      setSelectVisMetricsOptions(hasDataMetricsOption || []);
      setTrendError(false);
    } catch {
      if (!isLatestStatsRequest()) return;
      setSumAvgMaxList([]);
      setTrendTableList([]);
      setTrendLineList([]);
      setTrendError(true);
      setVisuailsMetricValues(defaultMetricValues?.slice(0, 2));
    } finally {
      if (isLatestStatsRequest()) {
        setLoading(false);
        setTrendLoading(false);
      }
    }
    if (!isLatestStatsRequest()) return;
    const updatedFetchParams: any = updateDefaultTimeParams({
      fetchParams: newFetchParams,
      startDate,
      endDate,
      period: newFetchParams.date_type,
      isTwoMonths,
    });
    setFetchParams(updatedFetchParams);
  };

  const handleConfirm = (value: any, apiValue: any) => {
    const newFetchParams = { ...fetchParams, ...value };
    if (JSON.stringify(newFetchParams) !== JSON.stringify(fetchParams)) {
      const dateTypeChanged = newFetchParams.date_type !== fetchParams.date_type;
      const paramsForNormalize =
        dateTypeChanged && saveParams?.metrics?.length
          ? {
              ...newFetchParams,
              source_metrics: rebuildSourceMetricsFromMetricValues(
                saveParams.metrics,
                newFetchParams.date_type,
              ),
            }
          : newFetchParams;
      const normalizedMetricsParams = normalizeMetricsByDateType(
        paramsForNormalize,
        saveParams?.metrics,
      );
      // 参数有变化才获取页面接口
      getStatsData(
        normalizedMetricsParams.fetchParams,
        normalizedMetricsParams.metricsOptions,
        false,
        saveParams?.metrics,
      );
      // 请求最早时间接口
      getEarliestDate(normalizedMetricsParams.fetchParams);
    }
  };

  const handleChangeExtra = (key: string) => {
    if (key === 'region') {
      userManuallyChangedRegionRef.current = true;
      updateURLSearchParams({ custom_region: true });
    }
  };

  const handleMetricSelectConfirm = (params: any) => {
    const { metricsObj, metricsOptions, metricsValue, metricTypeValue, sourcesValue } = params;
    const userSaveParams: IAllMetricsSaveParams = {
      sources: sourcesValue,
      types: metricTypeValue,
      metrics: metricsValue,
      source_metrics: metricsObj?.source_metrics,
    };

    latestMetricsSelectionRef.current = {
      metrics: metricsValue,
      source_metrics: metricsObj?.source_metrics,
    };

    // 移除列宽配置（仅影响当前 PC/Console Games Details Stats 页面）
    setSelectMetricsOptions(removeColumnWidth(metricsOptions || []));
    setSaveParams(userSaveParams);
    updateUserSaveParams(userSaveParams);

    const sourceMetricsKeys = Object.keys(metricsObj.source_metrics);

    const isOnlyMscienceMetric =
      sourceMetricsKeys?.length === 1 && sourceMetricsKeys[0] === 'mscience';

    /**
     * PC&Console 榜单页将地区指定为 us 条件
     * 1. 用户只选中了指定 MScience 指标
     * 2. 当前区域为全球，用户未更改
     */
    const shouldSetUSRegion =
      isOnlyMscienceMetric &&
      fetchParams.regions?.[0] === 'global' &&
      !userManuallyChangedRegionRef.current;

    /**
     * PC&Console 榜单页将地区重置为 global 条件
     * 1. 用户选中了除指定 MScience 指标还包括其他指标
     * 2. 当前地区为自动指定的 us，用户未更改
     */
    const shouldResetGlobalRegion =
      !isOnlyMscienceMetric &&
      fetchParams.regions?.[0] === 'us' &&
      !userManuallyChangedRegionRef.current;

    const newFetchParams = {
      ...fetchParams,
      ...(shouldSetUSRegion ? { regions: ['us'] } : {}),
      ...(shouldResetGlobalRegion ? { regions: ['global'] } : {}),
      source_metrics: metricsObj?.source_metrics,
    };

    // 请求接口
    getStatsData(newFetchParams, metricsOptions, true, metricsValue);
  };

  const getDownloadFetchParams = () => {
    const removeKeys = [
      'b_true_data',
      'b_group_by_date',
      'b_growth_ratio',
      'b_sum_avg_show',
      'b_group_by_market',
      'b_group_by_region',
      'b_group_by_platform',
      'b_group_by_segment',
      'start_release_time',
      'end_release_time',
    ];
    let fetchParamsNew = SteamSalesAdapter.convertAllMetricsTrendsParams(fetchParams);
    fetchParamsNew = omit(fetchParamsNew, removeKeys);
    const latestMetricsSelection = latestMetricsSelectionRef.current;
    const sourceMetricsResolved =
      latestMetricsSelection?.source_metrics ||
      saveParams?.source_metrics ||
      fetchParams.source_metrics ||
      defaultSourceMetricsApi;
    const metricsOrder =
      latestMetricsSelection?.metrics?.length
        ? latestMetricsSelection.metrics
        : saveParams?.metrics ||
          getSelectMetricsOptions()
            ?.map((item: any) => item?.value)
            ?.filter(Boolean) ||
          [];
    return {
      ...fetchParamsNew,
      ...fetchParams,
      source_metrics: sourceMetricsResolved,
      metrics: metricsOrder,
      order_metrics: buildOrderMetricsFromPageMetricValues(
        metricsOrder,
        sourceMetricsResolved,
      ),
      unified_id: gameId,
      unified_ids: [gameId],
      currentMetric: 'allMetrics',
      subSegment,
      isCountriesPage,
    };
  };

  const getCardStatus = (tabType: string) => ({
    isLoading: loading || trendLoading,
    isError: trendError,
    isNoData: !trendTableList?.length,
  });
  const goKpiTrend = () => {
    history.replace(`/intelligence/topCharts/pcConsoleGames/gamesDetails/${gameId}/stats`);
  };
  const pageSortAttr = getDefaultPageSortAttr(isStatsPage, 'desc', 'sales');

  const tableMetricListExpanded = useMemo(
    () =>
      expandMetricOptionsWithMultiValue(
        selectMetricsOptions,
        trendTableList,
        formatMessage,
      ),
    [selectMetricsOptions, trendTableList, formatMessage],
  );

  return (
    <>
      <div className="dbi-mobile-go-kpi">
        <MetricSelect
          key={fetchParams.date_type}
          loading={metricsLoading}
          dateGranularityType={fetchParams.date_type}
          metricTypeOptions={metricTypeOptionsByDateType}
          sourcesOptions={allMetricsSourcesOption}
          metricsOptions={metricsOptionsByDateType}
          resolveMetricType={getPCConsoleMetricDisplayCategory}
          disableSourcesWithoutMetrics
          // 上次用户选择的值
          metricTypeVals={Array.isArray(saveParams.types) ? saveParams.types : [saveParams.types]}
          sourceVals={saveParams.sources}
          metricsVals={saveParams.metrics}
          // reset默认值
          defaultMetricTypeVals={defaultMetricTypeVals}
          defaultSourceVals={defaultSourceVals}
          defaultMetricsVals={defaultMetricsVals}
          hendalConfirm={handleMetricSelectConfirm}
        />
        {entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE && (
          <span>
            <span style={{ position: 'relative', top: '0.8px' }}>{formatMessage({ id: `dbi_kpi_trends_jump` })}</span>
            <Button type="link" onClick={goKpiTrend} style={{ fontSize: '14px' }}>
              {formatMessage({ id: `dbi_kpi_trends` })}
            </Button>
          </span>
        )}
      </div>
      <div className="dbi-statsfilter-warp">
        <div className="statsfilter-warp-left">
          <Filter
            ref={filterInstance}
            // pageId={pageId}
            timeFilterValues={{
              type: fetchParams.date_type,
              value: [fetchParams.start_date, fetchParams.end_date],
            }}
            // buttonLogConfig={{}}
            filterConfirm={handleConfirm}
            onChangeExtra={handleChangeExtra}
            filterReset={() => {}}
            // filterInit={() => { }}
            sinceReleaseTime={baseReleaseTimeValue}
            earliestDataTime={earliestPeriod}
            filterValue={filterValue}
            setFilterVale={setFilterVale}
            filterCfg={filterCfg}
            defaultValue={DEFAULT_FORM_VALUE}
          />
        </div>
        <div className="dbi-statsfilter-warp-right">
          <ExportTable
            entityType={entityType}
            tabType={tabType}
            tableParams={getDownloadFetchParams()}
            isDisableDownload={trendLoading}
            isShowMaxDownloadRowsTips={false}
            downloadModalSize={820}
            isDisableDataAmount={true}
            newStyleFileName={`${basicInfo?.name}${
              isStatsPage ? '_Stats' : isCountriesPage ? '_Countries' : ''
            }`}
            pageId={
              entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE
                ? TopchartPageId.PCConsoleMetricsTable
                : undefined
            }
            gsdDevicesFlatten={gsdDevicesFlatten}
            gsdSegments={gsdSegments}
            useWebDownload={true}
            businessType="combine-detail-allmetrics"
            downloadKey="combineStatsAllMetrics"
            downloadLogConfigKey={pcconsoleStats?.[`${entityType}_${tabType}_${mainSegment}`]}
          />
        </div>
      </div>
      <CombineContent
        className={classnames('dbi-trend-allmetrics dbi-trend-allmetrics-actualy', {
          'dbi-trend-allmetrics-with-axis-title': visuailsMetricValues?.length === 2,
        })}
        cardTitle={
          <>
            {formatMessage({ id: `dbi_detail_trend` })}{' '}
            <TipContext
              className="card-slot-v2-right-tip"
              Performance="left"
              tipText={`${formatMessage({
                id: `dbi_detail_earliest_date`,
              })}: ${formattedEarliestDay}`}
            />
          </>
        }
        pageId={pageId}
        entityType={entityType}
        isCountriesPage={isCountriesPage}
        fixedTableData={[]}
        tableData={isCountriesPage ? marketTableList : trendTableList}
        sumAvgMaxList={sumAvgMaxList}
        lineData={isCountriesPage ? marketChartList : trendLineList}
        barData={isCountriesPage ? marketTableList : []}
        pieData={[]}
        stackBarData={[]}
        stackLineData={[]}
        stackPieData={[]}
        chartType={isCountriesPage ? marketChartType : trendChartType}
        setChartType={isCountriesPage ? setMarketChartType : setTrendChartType}
        metricSegVal={metricSegVal}
        setMetricSegVal={(value: string) => {
          setMetricSegVal(value);
        }}
        cardStatus={getCardStatus(tabType)}
        pageCfg={{ ...(pageCfg || {}), tableMetricList: tableMetricListExpanded }}
        earliestDay={formattedEarliestDay}
        baseReleaseTime={baseReleaseTimeData}
        firstWeekReleaseTime={baseReleaseTimeValue}
        earliestPeriod={earliestPeriod}
        defaultByDeviceVal={defaultByDeviceVal}
        dateType={fetchParams?.date_type}
        startDate={fetchParams?.start_date}
        endDate={fetchParams?.end_date}
        pageSortAttr={pageSortAttr}
        chartLoading={trendChartLoading}
        setChartLoading={setTrendChartLoading}
        visualisMetric={metricSegVal}
        visualisTitleNow={formatMessage({ id: 'dbi_data' })}
        gameName={basicInfo?.name}
        gameCover={basicInfo?.cover}
        changeDeviceBtn={(val: boolean) => {
          setDeviceBtn(val);
        }}
        regionsCountries={regionsCountries || []}
        visuailsMetricValues={visuailsMetricValues}
        leftDom={
          <VisuailsMetricSelector
            useAllSelectedOptionsDisplay
            disabled={!selectVisMetricsOptions?.length}
            options={selectVisMetricsOptions}
            defaultValues={visuailsMetricValues || []} // 操作指标弹窗后，拿到有数据的前2个做为默认值
            visuailsMetricValues={visuailsMetricValues}
            setVisuailsMetricValues={setVisuailsMetricValues}
          />
        }
        chartNodataMsg={`<span style="line-height:16px;font-size:14px;margin-top:-50px">
                        ${formatMessage({ id: 'dbi_info_allMetrics_nodatamsg' })}</span>`}
        onMetricExplanationClick={(key, payload) => {
          if (entityType !== PC_CONSOLE_COMBINE_ENTITY_TYPE) return;
          handleMetricExplanationTipsClick(key, payload, {
            filterValue: {},
            // @ts-ignore
            onClickSetRegionUSOnly: (filterValuePayload) => {
              const formValueTmp = filterInstance.current?.getFormValue();
              filterInstance.current?.setFormValue({
                ...formValueTmp,
                [filterKeyMap.REGION]: {
                  ...formValueTmp?.[filterKeyMap.REGION],
                  ...filterValuePayload?.[filterKeyMap.REGION],
                },
              });
              // @ts-ignore
              handleConfirm({
                ...fetchParams,
                region_type: 'market',
                regions: ['us'],
              });
            },
          });
        }}
      />
    </>
  );
};
